import { render, staticRenderFns } from "./MemberDues.vue?vue&type=template&id=38b31ee4"
import script from "./MemberDues.vue?vue&type=script&lang=js"
export * from "./MemberDues.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports